import * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'
import { cn } from '@/lib/utils'

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex h-[18px] w-[33px] shrink-0 cursor-pointer items-center',
      'rounded-full transition-colors focus-visible:outline-none',
      'focus-visible:ring-2 focus-visible:ring-slate-800 focus-visible:ring-offset-2',
      'focus-visible:ring-offset-white disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:bg-slate-800 data-[state=unchecked]:bg-neutral-300',
      className
    )}
    ref={ref}
    {...props}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-4 w-4 rounded-full bg-white shadow-sm',
        'ring-0 transition-transform data-[state=checked]:translate-x-4',
        'data-[state=unchecked]:translate-x-[1px]'
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
